import React, {useEffect} from 'react';
import {useTitle} from "../../../contexts/title";
import StoreNoteGrid from '../../../features/cfi/notes/components/StoreNoteGrid';
import {KindOfOrder} from '../../../types/enums';

export default function RetailOrderNotesPage() {

	const pageTitle = useTitle();
	useEffect(() => {
		pageTitle.setTitle('Retail Order Notes')
	}, [pageTitle]);

	return (
		<React.Fragment>
			<div className={'content-block'}>
				<StoreNoteGrid kindOfOrder={KindOfOrder.RetailOrder} />
			</div>
		</React.Fragment>
	)
} 
